import { motion } from "framer-motion";

const Emblem = ({ className = "w-56 h-auto", animate = true, ...rest }) => (
  <motion.img
    src="/emblem.png"
    alt="Emblema de Javier Alagrande — sombrero Panamá y vaso de whisky"
    data-testid="brand-emblem"
    className={className}
    initial={animate ? { opacity: 0, scale: 0.92, y: 18 } : false}
    animate={animate ? { opacity: 1, scale: 1, y: 0 } : undefined}
    transition={{ duration: 1.2, ease: [0.22, 1, 0.36, 1] }}
    {...rest}
  />
);

export default Emblem;
